(function($, undefined){

    var dataKey = "mouseidleTimer";

    $.mouseidleOptions = {
        timeout: 300
    };

    $.event.special.mouseidle = {
        setup: function(data, namespaces) {
            $(this).on('mousemove', $.event.special.mouseidle.moveHandler);
            $(this).on('mouseleave', $.event.special.mouseidle.leaveHandler);
        },

        teardown: function(namespaces) {
            $(this).each(function() {
                var elem = $(this);
                clearTimeout(elem.data(dataKey));
                elem.off('mousemove', $.event.special.mouseidle.moveHandler);
                elem.off('mouseleave', $.event.special.mouseidle.leaveHandler);
            });
        },

        moveHandler: function(event) {
            var self = this,
                elem = $(this),
                args = arguments,
                timeoutId = elem.data(dataKey);

            clearTimeout(timeoutId);

            timeoutId = setTimeout(function() {
                event.type = "mouseidle";
                $.event.dispatch.apply(self, args);
            }, $.mouseidleOptions.timeout);

            elem.data(dataKey, timeoutId);
        },

        leaveHandler: function(event) {
            var elem = $(this),
                timeoutId = elem.data(dataKey);

            clearTimeout(timeoutId);
            elem.data(dataKey, null);
        }
    };


} (jQuery));
